import script from "./ColorThemeButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorThemeButton.vue?vue&type=script&setup=true&lang=js"

import "./ColorThemeButton.vue?vue&type=style&index=0&id=111b6378&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-111b6378"]])

export default __exports__